import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import { toPounds } from '../../helpers/Currency';
import { GlobalModals } from '../../constants/AppConstants';
import ModalActions from '../../actions/ModalActions';
import Order from '../../records/Order';
import ShoppingBasketIcon from '../icons/ShoppingBasketIcon';

import Price from '../general/Price';


function BasketLink ({ order, showIcon, className, onClick }) {

    const _handleClick = () => ModalActions.open(GlobalModals.BASKET) && onClick();

    return (
        <button
            key={ order.trips.size }
            type="button"
            aria-label={ t('ariaLabel.basketButton', { journeys: order.trips.size, price: `£${toPounds(order.getTotalPrice()).toFixed(2)}` }) }
            className={ className }
            onClick={ _handleClick }
            role="link"
            tabIndex="0"
        >
            { showIcon && <ShoppingBasketIcon /> }

            <span className="navlink__journey-count--mobile visible-mobile visible-tablet-portrait">{ order.trips.size }</span>
            <span className="hidden-mobile hidden-tablet-portrait">
                <span className="navlink__journey-count">
                    { t('header.basket.journeyText', { journeys: order.trips.size }) }
                </span>
                <Price price={ order.getTotalPrice() } />
            </span>
        </button>
    );
}

BasketLink.propTypes = {
    order: PropTypes.instanceOf(Order).isRequired,
    className: PropTypes.string,
    showIcon: PropTypes.bool,
    onClick: PropTypes.func
};

BasketLink.defaultProps = {
    className: 'navlink__basket btn',
    showIcon: true,
    onClick: _.noop
};

export default BasketLink;



// WEBPACK FOOTER //
// ./src/components/nav/BasketLink.js